/** 域名 */
import React from 'react';
import ReactEcharts from '../Echarts/ReactEcharts';

class DOMEcharts extends React.Component{
  timeIdx;
  // 重绘
  UNSAFE_componentWillReceiveProps = () => {
    clearTimeout(this.timeIdx);
    this.timeIdx = setTimeout(() => {
      if (this.refs.DOMEcharts) {
        this.refs.DOMEcharts.updateEcharts();
      }
    }, 60);
  };
  // 绘图
  getOption() {
    const {echartsData} = this.props;
    let name = [];
    let value = [];
    echartsData.forEach(item => {
      value.push(item.value);
      name.push(item.name);
    });
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '40',
        right: '40',
        top: '40',
        bottom: '10',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          axisLabel: {
            interval: 0,
            rotate: 15,
            formatter:function(params){
              // 每行12个字节 `${arr[1].replace(/(.{12})/g, '$1\n')}`
              if (!params.includes('//')) {
                return params;
              } else {
                return params.split('//')[1];
              }
            }
          },
          nameTextStyle: {
            color: '#333'
          },
          data: name
        }
      ],
      yAxis: [
        {
          type: 'value',
          scale: true,
          name: '域名',
          min: 0,
          boundaryGap: [0.2, 0.2]
        }
      ],
      series: [
        {
          name: '域名',
          type: 'bar',
          itemStyle : {
            color:'#3AA1FF',
            lineStyle:{
              color:'#3AA1FF'
            }
          },
          barMaxWidth: 150,
          data: value
        }
      ],
      // 滚动条
      // dataZoom: [
      //   {
      //     show: LEN > 4,
      //     bottom: 0,
      //     minSpan: (100 / LEN),
      //     maxSpan: (400 / LEN),
      //     endValue: 3, //从0开始的相当于4个
      //     showDetail: false,
      //     borderWidth: 0,
      //     moveHandleSize: 0,
      //     height: 10,
      //     handleStyle: {
      //       opacity: 0
      //     }
      //   }
      // ]
    };
    return option;
  };
  render() {
    const {echartsData} = this.props;
    return (
      <ReactEcharts ref='DOMEcharts' key='DOMEcharts' option={this.getOption()} isHide={echartsData.length === 0} w='50%' h={300}></ReactEcharts>
    );
  }
};
export default DOMEcharts;
